import { useState } from 'react';
import Modal from 'react-modal';
import countryList from 'react-select-country-list';
import styles from '../css/Withdraw.module.css'; // Adjust the path as needed

// API Handler (This part won't be actually used in this file. It's here for context.)
async function handleWithdrawRequest(data) {
  const response = await fetch('/api/withdraw', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Withdrawal request failed');
  }
  return await response.json();
}

const Withdraw = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [country, setCountry] = useState('');
  const [paymentOption, setPaymentOption] = useState('');
  const [paymentInfo, setPaymentInfo] = useState('');
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [withdrawalDetails, setWithdrawalDetails] = useState({
    name: '',
    email: '',
    mobileNumber: '',
    accountNumber: '',
    walletAddress: '',
    blockchain: ''
  });
  const [confirmed, setConfirmed] = useState(false);

  const countries = countryList().getData();

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    setPaymentOption('');
    setPaymentInfo('');
    switch (selectedCountry) {
      case 'Pakistan':
        setPaymentOptions(['JazzCash', 'EasyPaisa', 'Visa Card', 'PayPal', 'Wallet Address']);
        break;
      case 'India':
        setPaymentOptions(['Paytm', 'PayPal', 'Wallet Address']);
        break;
      default:
        setPaymentOptions(['PayPal', 'Wallet Address']);
        break;
    }
  };

  const handlePaymentOptionChange = (selectedOption) => {
    setPaymentOption(selectedOption);
    switch (selectedOption) {
      case 'JazzCash':
      case 'EasyPaisa':
        setPaymentInfo('Enter your mobile number and name');
        break;
      case 'Paytm':
        setPaymentInfo('Enter your Paytm details');
        break;
      case 'Visa Card':
        setPaymentInfo('Enter your Visa Card details');
        break;
      case 'PayPal':
        setPaymentInfo('Enter your PayPal account information');
        break;
      case 'Wallet Address':
        setPaymentInfo('Select blockchain and enter your wallet address');
        break;
      default:
        setPaymentInfo('');
        break;
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setWithdrawalDetails({ ...withdrawalDetails, [name]: value });
  };

  const handleBlockchainChange = (event) => {
    setWithdrawalDetails({ ...withdrawalDetails, blockchain: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await handleWithdrawRequest({
        country,
        paymentOption,
        paymentInfo,
        withdrawalDetails,
      });

    } catch (error) {
      console.error('Error submitting withdrawal details:', error);
    }

    setCountry('');
    setPaymentOption('');
    setPaymentInfo('');
    setWithdrawalDetails({
      name: '',
      email: '',
      mobileNumber: '',
      accountNumber: '',
      walletAddress: '',
      blockchain: ''
    });
    setConfirmed(false);
    setIsOpen(false);
  };

  const handleConfirm = () => {
    if (country && paymentOption && paymentInfo && (paymentOption !== 'Wallet Address' || (paymentOption === 'Wallet Address' && withdrawalDetails.blockchain && withdrawalDetails.walletAddress))) {
      setConfirmed(true);
    } else {
      alert('Please fill in all required fields');
    }
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className={styles.modal}
        overlayClassName={styles.overlay}
      >
        <button onClick={() => setIsOpen(false)} className={styles.closeButton}>
          &times;
        </button>
        {!confirmed ? (
          <>
            <h2 className={styles.title}>Select Your Country</h2>
            <form onSubmit={handleSubmit} className={styles.form}>
              <label className={styles.label}>
                Country:
                <select onChange={(e) => handleCountryChange(e.target.value)} className={styles.select}>
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country.value} value={country.label}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </label>
              {country && (
                <>
                  <label className={styles.label}>
                    Payment Option:
                    <select onChange={(e) => handlePaymentOptionChange(e.target.value)} className={styles.select}>
                      <option value="">Select Payment Option</option>
                      {paymentOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </label>
                  {paymentOption && (
                    <div className={styles.details}>
                      <h3 className={styles.subTitle}>{paymentOption} Details:</h3>
                      <p>{paymentInfo}</p>
                      {paymentOption === 'Visa Card' && (
                        <>
                          <label className={styles.label}>
                            Card Number:
                            <input
                              type="text"
                              name="accountNumber"
                              value={withdrawalDetails.accountNumber}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                          <label className={styles.label}>
                            Expiration Date:
                            <input
                              type="text"
                              name="expirationDate"
                              value={withdrawalDetails.expirationDate}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                          <label className={styles.label}>
                            Security Code (CVV):
                            <input
                              type="text"
                              name="cvv"
                              value={withdrawalDetails.cvv}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                          <label className={styles.label}>
                            Cardholder Name:
                            <input
                              type="text"
                              name="name"
                              value={withdrawalDetails.name}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                        </>
                      )}
                      {paymentOption === 'PayPal' && (
                        <>
                          <label className={styles.label}>
                            PayPal Account:
                            <input
                              type="text"
                              name="email"
                              value={withdrawalDetails.email}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                        </>
                      )}
                      {paymentOption === 'Wallet Address' && (
                        <>
                          <label className={styles.label}>
                            Blockchain:
                            <select onChange={handleBlockchainChange} value={withdrawalDetails.blockchain} required className={styles.select}>
                              <option value="">Select Blockchain</option>
                              <option value="Ethereum">Ethereum</option>
                              <option value="Bitcoin">Bitcoin</option>
                            </select>
                          </label>
                          <label className={styles.label}>
                            Wallet Address:
                            <input
                              type="text"
                              name="walletAddress"
                              value={withdrawalDetails.walletAddress}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                        </>
                      )}
                      {(paymentOption === 'JazzCash' || paymentOption === 'EasyPaisa') && (
                        <>
                          <label className={styles.label}>
                            Mobile Number:
                            <input
                              type="text"
                              name="mobileNumber"
                              value={withdrawalDetails.mobileNumber}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                          <label className={styles.label}>
                            Name:
                            <input
                              type="text"
                              name="name"
                              value={withdrawalDetails.name}
                              onChange={handleInputChange}
                              required
                              className={styles.input}
                            />
                          </label>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
              <button type="button" onClick={handleConfirm} className={styles.confirmButton}>
                Confirm
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Withdrawal Request Submitted</h2>
            <p className={styles.message}>Your withdrawal request has been submitted successfully. We will process it shortly.</p>
            <button onClick={() => setIsOpen(false)} className={styles.closeButton}>
              Close
            </button>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Withdraw;
